export const onOpenScreenDashCliente = (display, modal) => {
  var element1 = document.getElementById("dash-clientes-theme-header");
  var element2 = document.getElementById("dash-clientes-theme-informacion");
  var element3 = document.getElementById("dash-clientes-theme-informacion");
  var element4 = document.getElementById(
    "dash-cientes-solicitud-credito-theme"
  );
  if (element1 != undefined && element2 != undefined && element3 != undefined) {
    element1.style.display = display;
    element2.style.display = display;
    element3.style.display = display;
    element4.style.display = modal;
  }
};

export const onHomeDashClientes = () => {
  onOpenScreenDashCliente("flex", "none");
};
